import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import ProvideLandingSearch from "../../providers/ProvideLandingSearch";
import AffiliatorsApp from "../../affiliators/App";

export default function Landing() {
  return (
    <>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <ProvideLandingSearch>
          <AffiliatorsApp />
        </ProvideLandingSearch>
      </ProvideLoggedInUser>
    </>
  );
}
